module.exports = __webpack_public_path__ + "img/konto_bankowe.d081b170.png";